import { forwardRef } from 'react'
import {
  Radio as ThemeUIRadio,
  RadioProps as ThemeUIRadioProps,
} from 'theme-ui'

export type RadioProps = ThemeUIRadioProps & {}

export const Radio = forwardRef<HTMLInputElement, RadioProps>(
  ({ ...rest }, ref) => <ThemeUIRadio ref={ref as any} {...rest} />
)
